import { AxiosResponse } from "axios";
import Vue from "vue";
import { ILoginRequest, ILoginResponse, ILogoutResponse } from "@/interfaces";
import { objectToFormData } from "object-to-formdata";


let baseURL =
	"https://www.rimguardrimrepair.com/specdev/bluetone/ajax/ApiAuth.aspx";


if (window.location.href.indexOf("localhost") > -1) {
	baseURL =
		"http://localhost:2344/specdev/bluetone/ajax/ApiAuth.aspx";
}


export const Login = async (data: ILoginRequest): Promise<ILoginResponse> => {
	const resp: AxiosResponse = await Vue.axios({
		method: "POST",
		url: baseURL,
		data: objectToFormData(data),
		params: {
			action: "login",
		},
	});
	return resp.data;
};

export const Logout = async (): Promise<ILogoutResponse> => {
	const resp: AxiosResponse = await Vue.axios({
		method: "POST",
		url: baseURL,
		data: {},
		params: {
			action: "logout",
		},
	});
	return resp.data;
};
